import React from 'react'

export const createCourseTourConfig = (t, isCreatingCourseByHuman = true) => {
    const steps = [
        {
            target: '.section',
            title: t('tour:create_course_step_0_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_0_content')}</p>
                </div>
            ),
            placement: 'center',
        },
        {
            target: '.create-course__content',
            title: t('tour:create_course_step_1_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_1_content')}</p>
                </div>
            ),
            placement: 'right',
        },
        {
            target: '[data-tour="course-title"]',
            title: t('tour:create_course_step_2_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_2_content')}</p>
                </div>
            ),
            placement: 'bottom',
        },
        {
            target: '[data-tour="course-cover-image"]',
            title: t('tour:create_course_step_3_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_3_content')}</p>
                </div>
            ),
            placement: 'right',
        },
    ]

    if (isCreatingCourseByHuman === true) {
        steps.push({
            target: '[data-tour="course-lessons"]',
            title: t('tour:create_course_step_4_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_4_content')}</p>
                </div>
            ),
            placement: 'left',
        })

        steps.push({
            target: '[data-tour="course-publish-button"]',
            title: t('tour:create_course_step_5_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_step_5_content')}</p>
                </div>
            ),
            placement: 'left',
        })
    } else {
        steps.push({
            target: '[data-tour="course-ai-next-button"]',
            title: t('tour:create_course_ai_step_title'),
            content: (
                <div>
                    <p>{t('tour:create_course_ai_step_content')}</p>
                </div>
            ),
            placement: 'left',
        })
    }

    return {
        id: 'create-course',
        name: t('tour:create_course_name'),
        description: t('tour:create_course_desc'),
        icon: 'plus-circle',
        steps
    }
}
